<template>
  <div class="selection_wrapper">
    <div class="form_group">
      <div
        :style="{color: activeColor}"
        class="selection"
        @click.stop="showSelection"
      >
        {{ initValue || '-请选择-' }}
      </div>
      <div
        v-if="showOptions"
        class="options_list"
      >
        <ul class="filter_level level0">
          <li
            v-for="item in addrLevel0"
            :key="item.value"
            :class="{'selected': level0_acitve && level0_acitve.id === item.id}"
            class="filter_level_item"
            @click="addrSelect(item, 0)"
          >
            {{ item.name }}
          </li>
        </ul>
        <ul
          v-if="addrLevel1.length"
          class="filter_level level1"
        >
          <li
            v-for="item in addrLevel1"
            :key="item.value"
            :class="{'sec_selected': level1_active && level1_active.id === item.id}"
            class="filter_level_item"
            @click="addrSelect(item, 1)"
          >
            {{ item.name }}
          </li>
        </ul>
        <ul
          v-if="addrLevel2.length"
          class="filter_level level2"
        >
          <li
            v-for="item in addrLevel2"
            :key="item.value"
            :class="{'third_selected': level2_active && level2_active.id === item.id}"
            class="filter_level_item"
            @click="addrSelect(item, 2)"
          >
            {{ item.name }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import { Message } from 'element-ui'
import { publish } from '@/api'
export default {
  name: 'AddrList',
  props: ['initValue', 'options', 'activeColor'],
  data() {
    return {
      addrLevel0: [],
      addrLevel1: [],
      addrLevel2: [],
      level0_acitve: {},
      level1_active: {},
      level2_active: {},
      showOptions: false
    }
  },
  created() {
    this.getLocation(0, '全部', 0)
  },
  methods: {
    getLocation(id, name, level, item = {}) {
      publish.getLocation(id).then(({ data: res }) => {
        // console.log("res", res)
        if (
          [-200, 500, 404].indexOf(res.status) !== -1 ||
          res.data.length === 0
        ) {
          this.submitAddr(item, level - 1)
          return
        }
        if (res.data && res.data.length) {
          // // 子级添加全部
          // if ([0, 1, 2].indexOf(level) >= 0) {
          //   try {
          //     if (res.data[0].id != -1) {
          //       res.data.unshift({
          //         parentId: id,
          //         parentName: name,
          //         parentAdCode: item.adcode,
          //         id: -1,
          //         name: "全部"
          //       })
          //     }
          //   } catch (e) {
          //     console.log(e)
          //   }
          // }
          // console.log("res.data", res.data)
          if (level == 0) {
            this.addrLevel0 = res.data
          } else if (level == 1) {
            this.addrLevel1 = res.data
          } else if (level == 2) {
            this.addrLevel2 = res.data
          }
        }
      })
    },
    /**
     *  地址筛选
     */
    addrSelect: function(item, level) {
      // console.log("item", item, item.level0, item.level1, level)
      if (item.name == '全部') return
      if (level === 0) {
        this.level0_acitve = { ...item }
        this.addrLevel1 = []
        this.addrLevel2 = []
      } else if (level === 1) {
        this.level1_active = {
          ...item,
          level0: { ...item.level0 },
          level1: { ...item.level1 }
        }
        this.addrLevel2 = []
      } else {
        this.level2_active = {
          ...item,
          level0: { ...item.level0 },
          level1: { ...item.level1 }
        }
        this.submitAddr(item, level)
        return
      }
      if (item.id === -1) {
        this.submitAddr(item, level)
      } else {
        this.getLocation(item.id, item.name, level + 1, item)
      }
    },
    /**
     * 提交选择结果
     */
    submitAddr: function(item, index) {
      let selectOb = {}
      if (item.id === -1) {
        selectOb = {
          id: item.parentId === 0 ? -1 : item.parentId,
          name: item.parentName === '全国' ? -1 : item.parentName
        }
      } else {
        selectOb = item
      }
      if (index === 2) {
        selectOb.level0 = this.level0_acitve
        selectOb.level1 = this.level1_active
        if (selectOb.level1.id != selectOb.id) {
          selectOb.level2 = {
            id: selectOb.id,
            name: selectOb.name
          }
        }
        selectOb.fullName = `${selectOb.level0.name}${selectOb.level1.name}${selectOb.name}`
      } else if (index === 1) {
        selectOb.level0 = this.level0_acitve
        if (selectOb.level0.id != selectOb.id) {
          selectOb.level1 = {
            id: selectOb.id,
            name: selectOb.name
          }
        }
        selectOb.fullName = `${selectOb.level0.name}${selectOb.name}`
      } else if (index === 0) {
        selectOb.fullName = selectOb.name
      }
      // console.log("selectOb", selectOb)
      // app.setGlobal("locationFilter", selectOb)
      // wx.navigateBack()
      this.showOptions = false
      this.selectThis(selectOb)
    },
    // 过滤菜单
    showSelection() {
      // console.log("this.options")
      // if (!this.options.length) {
      //   Message.info({ message: "请先输入正确的供应名称" })
      //   return
      // }
      this.showOptions = true
    },
    selectThis(item) {
      this.showOptions = false
      this.value = item.label
      this.$emit('selectCallback', item)
    }
  }
}
</script>
<style lang="less" scoped>
.selection_wrapper {
  width: 400px;
  line-height: 30px;
  border-radius: 2px;
  height: 30px;
  box-sizing: border-box;
  .form_group {
    position: relative;
  }
  .form_group::before {
    position: absolute;
    right: 10px;
    top: 60%;
    transform: translateY(-50%);
    content: "";
    width: 0;
    height: 0;
    border-width: 6px;
    border-color: #333 transparent transparent;
    border-style: solid dashed dashed;
  }
  .selection {
    width: 100%;
    height: 30px;
    padding: 0 10px;
    font-size: 14px;
    box-sizing: border-box;
    border: 1px solid #b7b7b7;
  }
  .options_list {
    left: 0;
    top: 30px;
    right: 0;
    position: absolute;
    overflow: hidden;
    border: 1px solid #b7b7b7;
    border-radius: 2px;
    border-top: 0 none;
    background: #fff;
    z-index: 11;
    min-height: 400px;
    li {
      flex: 1;
      list-style: none;
      padding: 5px 10px;
      font-size: 14px;
      color: #333;
      line-height: 20px;
      height: 20px;
      cursor: pointer;
      &:hover,
      &.highlight {
        background-color: #00ac8b;
        color: #fff;
      }
      &.selected {
        color: #333;
        background-color: #efefef;
      }
      &.sec_selected {
        background-color: #dfdfdf;
      }
      &.third_selected {
        background-color: #c1c0c0;
      }
    }
  }
  .filter_level {
    position: absolute;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
  }
  .level0 {
    background: #fff;
  }
  .level1 {
    background-color: #efefef;
    left: 33.3%;
    z-index: 10;
  }
  .level2 {
    background-color: #dfdfdf;
    left: 66.6%;
    z-index: 11;
  }
  .filter_level_item {
    padding-left: 24px;
    height: 80px;
    line-height: 80px;
  }
}
</style>
